import { render, staticRenderFns } from "./shopStoreBuyer.vue?vue&type=template&id=fcfc732a&"
import script from "./shopStoreBuyer.vue?vue&type=script&lang=js&"
export * from "./shopStoreBuyer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports